//helper
import Account from '@/helper/AccountHelper.js';
import ConfigManager from "@/config/ConfigManager.js";
import CacheHelper from "@/helper/CacheHelper.js";
import Locale from '@/helper/locale/Locale.js';
// import Util from '@/helper/Utility.js';
import { CampaignType } from "@/helper/StaticValue.js";
//core
// import { CallbackEvent } from '@/core/Utility/CallbackEvent.js';
//config
import {
    RedeemConfigBuilder,
    RedeemShippingAddressConfigBuilder
} from '@/core/Redeem/config/RedeemConfigBuilder.js';
//model
import { AddCartModel } from '@/core/Cart/model/CartModel.js';
//service
import BzbsCart from '@/core/Cart/service/BzbsCart.js';
import BzbsRedeem from '@/core/Redeem/service/BzbsRedeem.js';
import { DrawDeliveryModel } from '@/core/Redeem/model/DrawDeliveryModel.js';
import { SerialModel } from '@/core/Redeem/model/SerialModel.js';
// import { ModalController } from '../../../components/Modal/ModalController';

/**
 * event
 * @method onRedeemSuccess
 * @method onErrorApi
 * @method onRedirect
 */
export function RedeemController () {
    this.lbl = Locale.getLbl();
    this.localeCode = Locale.getLocaleCode();
    this.cacheHelper = new CacheHelper(ConfigManager.getCacheType());

    this.campaign = {};
    this.selectedCampaignId = null;
    this.selectedQuantity = null;

    this.redeemConfigBuilder = new RedeemConfigBuilder();
    this.modalController = null;

    // this.cbRedeemSuccess = new CallbackEvent();
    // this.cbRedirect = new CallbackEvent();
    // this.cbApiError = new CallbackEvent();

    //#region initial
    /**
     * @param {CampaignModel} campaign /core/Campaign/model/CampaignModel.js
     * @param {ModalController} modalController /components/Modal/ModalController.js
     */
    this.initial = (campaign, modalController) => {
        this.campaign = campaign;
        this.modalController = modalController;
    };
    /**
     * @param {CampaignModel} campaign /core/Campaign/model/CampaignModel.js
     */
    this.reinitial = (campaign) => {
        this.lbl = Locale.getLbl();
        this.campaign = campaign;
    }
    //#endregion initial

    //#region redeem
    /**
     * Click ปุ่ม Redeem แล้วจะเรียกที่นี่
     *      - show popup confirm
     * @param {Number} selectedCampaignId campaign id
     * @param {Number} selectedQuantity quanty
     */
    this.clickRedeem = (selectedCampaignId, selectedQuantity) => {
        if (!this.onClickRedeem()) {
            return;
        }
        this.selectedCampaignId = selectedCampaignId;
        this.selectedQuantity = selectedQuantity;
        this.confirmRedeem();
        // this.modalController.confirmRedeemModal
        //                     .clearModal()
        //                     .setCampaign(this.campaign)
        //                     .show()

        // this.modalController.confirmRedeemModal.onClickOk(() => {
        //     // event confirm redeem
        //     if (!this.onConfirmRedeem()) {
        //         return;
        //     }
        //     this.confirmRedeem();
        // });

        // this.modalController.confirmRedeemModal.onClickCancel(() => {
        //     // event cancel redeem
        //     this.onCancelRedeem();
        // });
    };

    /**
     * * Click popup Confirm Redeem แล้วจะเรียกที่นี่
     */
    this.confirmRedeem = () => {
        //% Open web Campaign Type 8
        if (this.isCampaignTypeInterFace()) {
            if (!this.onOpenInterface()) {
                return;
            }

            this.openWebInterface();
        }

        //% Open web Survey
        else if (this.isCampaignTypeSurvey() || this.isCampaignTypeAds()) {
            var surveyUrl = this.campaign.website;
            this.onOpenInterface({ type: 'web', link: surveyUrl });
            this.openWebInterface();
        }

        //% ไม่รู้คืออะไร เขียนไว้กันลืม
        else if (this.isCampaignTypeApi()) {
            this.onOpenInterface();
        }

        //% Add item to cart
        else if (this.isCampaignTypeBuy()) {
            if (!this.onAddToCart()) {
                return;
            }
            this.addToCart();
        }

        //% Open modal shipping
        else if (this.campaign.delivered) {
            if (!this.onOpenShipping()) {
                return;
            }

            this.openDeliveryCampaign();
        }

        //% Normal Redeem
        else {
            if (!this.onRedeem()) {
                return;
            }
            this.redeem();
        }
    };

    /**
     * * Redeem delivery open shipping address
     */
    this.openDeliveryCampaign = function() {
        if (ConfigManager.getAddressType() == "profile") {
            this.modalController.shippingAddressModal
                .clearModal()
                .setTitle(this.lbl.shipping.headline)
                .show();

            this.modalController.shippingAddressModal.onSaveAddress(address => {
                if (!this.onSaveShipping()) {
                    return;
                }
                this.redeemConfigBuilder.redeemShippingAddressConfigBuilder = address;
                this.redeem();
            });
        } else if (ConfigManager.getAddressType() == "addressList") {
            this.modalController.listAddressModal
                    .setNotShowModalAfterUpdate()
                    .show();
            this.modalController.listAddressModal.onUpdateSuccess((address) => {
                if (!this.onSaveShipping()) {
                    return;
                }
                let addressBuilder = new RedeemShippingAddressConfigBuilder();
                addressBuilder.setAddressFromDeliveryAddressModel(address);
                this.redeemConfigBuilder.redeemShippingAddressConfigBuilder = addressBuilder;
                this.redeem();
            });
        } else {
            console.log("มึงเขียนคอนฟิก Shipping Address ผิด");
        }
    };

    /**
     * * Call api Redeem
     */
    this.redeem = () => {
        // this.initialSerial()
        var params = this.redeemConfigBuilder.getRedeemParams();
        this.modalController.loadingModal.show();
        BzbsRedeem.apiRedeemCampaign(this.selectedCampaignId, params, this.selectedQuantity)
            .subscribe((campaign) => {
                this.modalController.loadingModal.hide();
                this.campaign.updateAfterRedeem(campaign);

                if (this.campaign.isNotAutoUse == false) {
                    this.redeemUse(this.campaign.redeemKey);
                } else {
                    this.initialSerial();
                }
                this.onRedeemSuccess(campaign);
            }, (err) => {
                this.modalController.loadingModal.hide();
                this.onRedeemError(err);
            });
    };

    this.redeemUse = (redeemKey) => {
        this.modalController.loadingModal.show();
        BzbsRedeem.apiRedeemUse(redeemKey)
            .subscribe((data) => {
                this.modalController.loadingModal.hide();
                this.campaign.updateAfterRedeem(data);
                this.initialSerial();
            }, (err) => {
                this.modalController.loadingModal.hide();
                this.onRedeemError(err);
            });
    };

    this.arrangeRedeem = (redeemKey) => {
        this.modalController.loadingModal.show();
        BzbsRedeem.apiArrangeRedeem(redeemKey)
            .subscribe(() => {
                this.modalController.loadingModal.hide();
                this.modalController.serialModal.hide();
                this.onRedirect('/promotion/special4you?tab=history');
            }, (err) => {
                this.modalController.loadingModal.hide();
                this.onRedeemError(err);
            });
    };
    //#endregion redeem

    //#region interface redeem open web
    this.openWebInterface = function() {
        //TODO: Setup link
        var webUrl = this.campaign.website;
        var isShowHeader = 'false';
        var theme = ConfigManager.getAppName();
        var suffledToken = Account.getTokenShuffle();
        if (webUrl.indexOf('/Topup/InterfaceLanding') >= 0 || webUrl.indexOf('starbucks') >= 0) {
            this.cacheHelper.setCache('isfromlanding', { page: 'interface'});
        }else if(this.isLandingDtac(webUrl) || this.isLandingAis(webUrl)){ //ais , dtac set to interface
            this.cacheHelper.setCache('isfromlanding', { page: 'interface'});
        }else if (webUrl.indexOf('wondd') >= 0) {
            this.cacheHelper.setCache('isfromlanding', { page: 'wodd'});
        }else {
            this.cacheHelper.setCache('isfromlanding', { page: 'other'});
        }

        webUrl += '&token=' + suffledToken
                + '&locale=' + this.localeCode
                + '&header=' + isShowHeader
                + '&theme=' + theme
            + '&return_url=' + encodeURIComponent(window.location.href)
            + '&success_survey_url=' + encodeURIComponent(window.location.href.replace(location.pathname, '/promotion/hot'));

        // support history truemoney
        if (webUrl.indexOf('wondd/truemoney') == -1 && webUrl.indexOf('truemoney') >= 0) {
            webUrl += '&history_url=' + encodeURIComponent(window.location.href + '/history');
        }
        window.location.href = webUrl;
    };
    //#endregion interface redeem open web
    this.isLandingDtac = (webUrl) => {
        if(webUrl.indexOf('Dtac') >= 0 || webUrl.indexOf('dtac') >= 0){
            return true;
        }
        return false
    }
    this.isLandingAis = (webUrl) => {
        if(webUrl.indexOf('Ais') >= 0 || webUrl.indexOf('ais') >= 0){
            return true;
        }
        return false
    }
    //#region buy
    this.addToCart = () => {
        var cartItem = new AddCartModel();
        var cartParams = cartItem.addItem(this.selectedCampaignId, this.selectedQuantity)
                            .getParams();

        BzbsCart.apiAddToCart(cartParams).subscribe((data) => {
            this.onAddToCartSuccess();
            console.log(data);
        }, (err) => {
            this.onAddToCartError(err);
        });
    };
    //#endregion buy

    //#region serial
    this.initialUsedSerial = () => {
        this.modalController.confirmUsedModal
            .clearModal()
            .setCampaign(this.campaign)
            .show();
        this.modalController.confirmUsedModal.onClickOk(() => {
            this.redeemUse(this.campaign.redeemKey);
        })
    };

    this.initialSerial = () => {
        if (this.campaign.delivered || this.campaign.type == CampaignType.Draw) {
            var drawDelivery = new DrawDeliveryModel();
            drawDelivery.setModelFromDataModel(this.campaign);
            this.modalController.drawDeliveryModal
                .setDrawDelivery(drawDelivery)
                .show();
        } else {
            var serial = new SerialModel();
            serial.setModelFromDataModel(this.campaign);
            this.modalController.serialModal
                .clearModal()
                .setSerial(serial)
                .show();
            this.modalController.serialModal.onCloseModal(() => {});
            this.modalController.serialModal.onSerialExpire(() => {});
            this.modalController.serialModal.onSlideToUsed(() => {
                this.arrangeRedeem(this.campaign.redeemKey);
            });
        }
    };
    //#endregion serial

    //#region event
    this.onClickRedeem = () => true;
    this.onConfirmRedeem = () => true;
    this.onCancelRedeem = () => true;
    this.onOpenInterface = () => true;
    this.onOpenShipping = () => true;
    this.onSaveShipping = () => true;
    this.onRedeem = () => true;
    this.onRedeemSuccess = () => true;
    this.onRedeemError = () => true;
    this.onAddToCart = () => true;
    this.onAddToCartSuccess = () => true;
    this.onAddToCartError = () => true;
    this.onRedirect = () => true;
    //#endregion event

    //#region private function
    this.isCampaignTypeInterFace = function() {
        return (this.campaign.type == CampaignType.Interface)
            && (this.campaign.interfaceDisplay == 'web');
    };
    this.isCampaignTypeSurvey = function() {
        return (this.campaign.type == CampaignType.Interface)
            && (this.campaign.interfaceDisplay == 'survey' || this.campaign.interfaceDisplay == 'surveyapprove');
    };
    this.isCampaignTypeApi = function() {
        return (this.campaign.type == CampaignType.Interface)
            && (this.campaign.interfaceDisplay == 'api');
    };
    this.isCampaignTypeBuy = function() {
        return (this.campaign.type == CampaignType.Buy);
    };
    this.isCampaignTypeAds = function(){
        return (this.campaign.type == CampaignType.Ads);
    }
    //#endregion private function
}
